import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppMaterialModule } from 'app/app-material.module';
import { RolePermissionsComponent } from '../create-merchant-single-employee/role-permissions/role-permissions.component';
import { CreateMerchantSingleEmployeeComponent } from '../create-merchant-single-employee/create-merchant-single-employee.component';
import { MerchantService, MerchantUserService } from 'app/services';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'merchant-employee-details',
  standalone: true,
  imports: [
    AppMaterialModule
  ],
  templateUrl: './merchant-employee-details.component.html',
  styleUrl: './merchant-employee-details.component.scss'
})
export class MerchantEmployeeDetailsComponent {

  loading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private merchantUserService: MerchantUserService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<MerchantEmployeeDetailsComponent>
  ){}

  getRolePermissions(){
    this.dialog.open(RolePermissionsComponent, {
        width: '40%',
        height: '80%',
        data: {
          type: this.data.type,
          merchantId: this.data.merchantId
        }
    });
  }

  editEmployee(){
    this.dialog.open(CreateMerchantSingleEmployeeComponent, {
        width: '60%',
        data: {
            type: this.data.type,
            merchantId: this.data.merchantId,
            employee: this.data.employee,
            isEditable: true,
            user: this.data.user
        }
    });
  }

  public deleteMerchantUser(merchantUserId: number) {
    const dto = {
        MerchantUserId: merchantUserId,
    };

    this.merchantUserService.deleteMerchantUserById(dto, this.messageService)
        .then(data => {
            this.loading = false;

            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully deleted' });
            this.dialogRef.close('Success');
        })
        .catch(err => {
            this.loading = false;
            throw err;
        });
  }
}
